export default `${process.env.NODE_ENV === "production" ? (process.env.REACT_APP_CLOUD_WEALTH_LIVE).toString() : (process.env.REACT_APP_CLOUD_WEALTH_LOCAL).toString()
}`